//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { jssdk, isIphonex } from '@runwork/runwork-help'
export default {
  props: {
    question: {
      type: Object,
      default: () => {},
    },
  },
  components: {},
  data() {
    return {
      editorOption: {
        modules: { toolbar: [] },
        placeholder: '请输入',
      },
    }
  },
  computed: {
    isIphonex() {
      return isIphonex() && this.platform === 3
    },
    isrunwork2() {
      return isIphonex() && this.platform === 2
    },
    editor() {
      return this.$refs['conclusion-title'].quill
    },
  },
  mounted() {
    let editor = this.editor
    if (editor) {
      this.$nextTick(() => {
        let len = editor.getLength()
        editor.setSelection(len)
      })
    }
  },
  // mounted() {
  //   let radioTitle = this.$refs['conclusion-title']
  //   if (radioTitle) {
  //     radioTitle.$refs['$textarea'].focus()
  //   }
  // },
  methods: {
    onEditorChange(event) {
      event.quill.deleteText(500, 4)
    },
    addQuestion(item) {
      this.$emit('onadd', this.question)
    },
  },
}
